import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectClimateMeasurementV2Domain = (state) =>
  state.get("climateMeasurementV2", initialState)

export const makeSelectIsLoadingDimensionsData = () =>
  createSelector(selectClimateMeasurementV2Domain, (state) =>
    state.get("isLoadingDimensionsData")
  )

export const makeSelectDimensionsData = () =>
  createSelector(selectClimateMeasurementV2Domain, (state) =>
    state.get("dimensionsData")
  )

const makeSelectClimateMeasurementV2 = () =>
  createSelector(selectClimateMeasurementV2Domain, (substate) =>
    substate.toJS()
  )

export default makeSelectClimateMeasurementV2
export { selectClimateMeasurementV2Domain }
